import { jsxs as u, jsx as i } from "react/jsx-runtime";
import "styled-components";
import { useThemeInMode as l } from "../../../../context/theme/hooks.js";
import { DISABLED_OPACITY as h } from "../../../../styles/colors/consts.js";
import n from "../../../content/Icon/Icon.js";
import "../../../../ActionButton-B77eJAd5.js";
import "react";
import "../../../layout/Stack/Stack.js";
import m from "../../../layout/Box/Box.js";
import "../../../../index-CZ8zjHGv.js";
import "../../../layout/Center/Center.js";
import "../../../../context/WindowSize/Dimensions.js";
import "lodash-es";
import "../../../layout/Columns/ColumnsContext.js";
import "../../../../hooks/link/index.js";
import "@material/material-color-utilities";
import "react-select";
import "react-select/async";
import "../../../typography/Text/Text.js";
import "../../../../context/Text.js";
import "../../../../context/Typography.js";
import "../../Toggle/CustomCheckbox.js";
import "focus-trap-react";
import "../../../content/Logo/consts.js";
function W({
  onClick: e,
  disabled: t,
  searchable: r,
  ariaLabel: o,
  children: p,
  menuIsOpen: s
}) {
  const a = l(), { controlStyles: c, iconStyles: d } = f({
    disabled: t,
    menuIsOpen: s,
    searchable: r
  });
  return /* @__PURE__ */ u(
    m,
    {
      type: "button",
      component: "button",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      "aria-label": o,
      onClick: e,
      borderRadius: "small",
      width: "100%",
      minHeight: "38px",
      paddingX: "large",
      paddingY: "small",
      cursor: "pointer",
      opacity: t ? h : "1",
      focusStyles: {
        outline: "0",
        borderColor: a["primary-high-content"]
      },
      ...c,
      children: [
        p,
        /* @__PURE__ */ i(m, { ...d, marginLeft: "large", children: r ? /* @__PURE__ */ i(
          n,
          {
            accessibilityLabel: "search",
            tone: "neutral",
            size: "medium",
            iconName: "search"
          }
        ) : /* @__PURE__ */ i(
          n,
          {
            accessibilityLabel: "open",
            tone: "neutral",
            size: "medium",
            iconName: "chevronDown"
          }
        ) })
      ]
    }
  );
}
function f({
  disabled: e,
  menuIsOpen: t,
  searchable: r
}) {
  const o = l();
  return {
    controlStyles: {
      color: o["neutral-medium-content"],
      borderStyle: "solid",
      borderWidth: "xxxsmall",
      borderColor: !e && t ? o["primary-high-content"] : o["neutral-high-content"],
      backgroundColor: o.foreground
    },
    iconStyles: {
      ...t && !r && {
        transition: "transform 0.2s ease",
        transform: "rotate(180deg)"
      }
    }
  };
}
export {
  W as default
};
